// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js","771":"component---src-pages-page-2-js"}[chunkId] + "-" + {"125":"9adede8a759c3b3243dd","223":"3e33d3cbd522cda2883f","293":"379fa097301f0461030e","771":"59981aeb31cfe2c681d8"}[chunkId] + ".js";
};